"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var material_kit_pro_react_1 = require("../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a;
    return (0, core_1.makeStyles)({
        root: __assign(__assign({}, material_kit_pro_react_1.container), { display: 'flex', flex: 1, flexDirection: 'column' }),
        formRow: {
            padding: '12px 0'
        },
        field: {
            width: '100%',
            marginTop: theme.spacing(),
            marginBottom: theme.spacing(),
            paddingBottom: theme.spacing()
        },
        button: (_a = {
                '&:disabled': {
                    backgroundColor: theme.palette.grey[600],
                    color: theme.palette.text.disabled
                },
                marginTop: theme.spacing(4),
                paddingTop: 10,
                paddingBottom: 10
            },
            _a[theme.breakpoints.up('md')] = {
                paddingLeft: theme.spacing(5),
                paddingRight: theme.spacing(5)
            },
            _a[theme.breakpoints.down('xs')] = {
                paddingLeft: theme.spacing(10),
                paddingRight: theme.spacing(10)
            },
            _a[theme.breakpoints.down('xs')] = {
                width: '100%'
            },
            _a),
        buttonContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: theme.spacing(3)
        },
        addressContent: {
            paddingRight: theme.spacing() + 4,
            paddingLeft: theme.spacing() + 4
        },
        buttonWrap: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map